<template>
  <DBox
    class="cmp-settings-billing-billing_settings_invoice"
    :id="'settings-billing-billing_settings_invoice'"
    :addButton="false"
    :rightMenu="rightMenuItems"
    @menuClick="onRightMenuClick"
  >
    <!-- <button 
    :disabled="batchPDFDownloadLoading" @click="batchPDFDownloadRequest" 
    class="dt-button v5 s8" 
    :class="batchPDFDownloadLoading ? 'disabled' : ''" 
    style="width:100px;margin-left:35px;margin-top:10px;" 
    v-if="checkedPaymentsID.length > 1">Download PDFs</button> -->

    <NTable
      :id="'settings-billing-billing_settings_invoice'"
      class="h2"
      :items="payment"
      :headers="paymentHeaders"
      :config="
        createNTableConfig({
          headerStyle: 3,
          rowHeight: 30,
          fullHeight: true,
          showHeader: true,
        })
      "
    >    
    <template v-slot:thead="{ thcon, thtext }">
        <tr>
          <th
            v-for="(header) in paymentHeaders"
            v-bind="thcon(header.value)"
            :key="header.value"
          >
            <div
              v-if="['left_options'].includes(header.value)"
              class="header-name"
              style="margin-top:-5px;"
            >
              <div class="check-buttons">
                <img style="height:17px; width:17px;" @click="e => onHeaderCheckboxChanged(e)" :src="`static/icons/arrows/${headerCheckboxIcon}.svg`" class="dt-icon checkbox" />
              </div>
            </div>
            <span
              v-else
              class="header-name"
              :style="{
                textAlign: header.ta || 'left',
              }"
            >
              {{ thtext(header.value) }}
            </span>
          </th>
        </tr>
      </template>
      <template v-slot:item="{ item, tdcon }">
        <tr>          
          <td v-bind="tdcon('left_options')">
            <div class="dt-checkbox v2 s1" style="margin: auto 5px;">
              <input type="checkbox" class="invoice-select-cb" @click="(e) => onInvoiceCheckboxChange(e, item)"
                :checked="checkedPaymentsID.includes(item.payment_id)" />
              <div class="checkmark"></div>
            </div>
          </td>
          <td v-bind="tdcon('invoice')">
            <span class="ut-link ut-text-accent5">
              <a :href="invoiceLink(item)" target="_blank">
                {{ item.clientID }}-{{ item.invoice }}
              </a>
            </span>
          </td>
          <td v-bind="tdcon('invoice_date')">
            <span>{{ invoiceDate(item) }}</span>
          </td>
          <td v-bind="tdcon('period')">
            <span>{{ invoicePeriod(item) }}</span>
          </td>
          <td v-bind="tdcon('net_amount')">
            <span>{{ item.amount }} EUR</span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>


<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { HttpClient } from "../../../../services/http/http-client";
import { InvoicesService } from "../../../accounting/services/invoices.service";
import { NotificationService } from "@dtplugins/notification/notification.service";

export default {
  components: {
    DBox,

    NTable,
  },
  props: {
    billingSettingsData: {
      type: Object,
    },
  },
  mounted: function () {},
  data: function () {
    return {
      checkedPaymentsID: [],
      batchPDFDownloadLoading: false,
    };
    //MARK: Data Function
  },

  computed: {
    payment: function () {
      console.log(
        "invoice-list.vue:80 this.billingSettingsData?.payment",
          this.billingSettingsData?.payment?.map((p) => {
            return {
              ...p,
              JSON: p.JSON ? JSON.parse(p.JSON) : {},
            };
          }) || [],
      );
      return (
        this.billingSettingsData?.payment?.map((p) => {
          return {
            ...p,
            JSON: p.JSON ? JSON.parse(p.JSON) : {},
          };
        }) || []
      );
    },
    paymentHeaders: function () {
      return [
        createTableHeader("left_options", { mw:25, ta: "center" }),
        createTableHeader("invoice", { f: 1 }),
        createTableHeader("invoice_date", { mw: 150, ta: "center" }),
        createTableHeader("period", { f:2 }),
        createTableHeader("net_amount", { ta: "right", f:.6 }),
      ];
    },        
    headerCheckboxIcon: function () {
      return this.payment.length>0 && this.checkedPaymentsID.length == this.payment.length ? 'checkbox-tick' : this.checkedPaymentsID.length == 0 ? 'checkbox' : 'checkbox-minus';
    },
    rightMenuItems(){
      return [
        {
          text: this.$t('batch_pdf_download'),
          value: 'download_pdfs',
          disabled: this.checkedPaymentsID.length < 1,
          disabledTooltip: this.$t('batch_pdf_download_hints')
        },
      ];
    }
  },

  methods: {
    createNTableConfig: createNTableConfig,

    invoiceDate: function (item) {
      return item.timestamped?.split(" ")[0] || "";
    },
    invoicePeriod: function (item) {
      return item.JSON?.invoice_lines?.[0]?.description || "";
    },
    invoiceLink: function (item) {
      return `${HttpClient.getBaseUrl()}/billing.pl?invoice=${
        item.invoice
      }&action=display%20invoice`;
    },
    onHeaderCheckboxChanged(e) {
      if(this.headerCheckboxIcon == 'checkbox-tick'){
        this.checkedPaymentsID = [];
      }else{
        this.checkedPaymentsID = this.payment.map(r => r.payment_id);
      }
    },
    onInvoiceCheckboxChange: function (e, item) {
      const checked = e.target.checked;
      
      if(checked){
        this.checkedPaymentsID = [...this.checkedPaymentsID, item.payment_id];
      }else{
        this.checkedPaymentsID = this.checkedPaymentsID.filter(r => r != item.payment_id);
      }
    },
    batchPDFDownloadRequest: async function () {
      const payment_ids = this.checkedPaymentsID.join();
      // console.log('mdsir: payment_ids', payment_ids);
      this.batchPDFDownloadLoading = true;
      
      const { domain_tld } = window.HttpClient.getBaseURLObject();
      const res = await InvoicesService.batchPDFDownload({domain_tld:domain_tld,type: "billing_invoice", ids: payment_ids });
      NotificationService.showNotification({
        text: this.$t('pdf_download_processing_message'),
        timeout: 10000,
      });
      this.batchPDFDownloadLoading = false;
    },
    onRightMenuClick: async function (menu) {
      // console.log('mdsir: right menu', menu);
      this.batchPDFDownloadRequest();
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-billing-billing_settings_invoice,
.cmp-settings-billing-support_issue {
  height: 100%;

  .invoice {
    a {
      color: unset;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>